

















import { Component, Vue, Prop } from "vue-property-decorator";
import { JobHistoryItem } from "../../common/interfaces";
import store from "@/store/store";
import moment from "moment";
import axios from "axios";

@Component({})
export default class PastJob extends Vue {
  @Prop() public job: JobHistoryItem;

  get fullDescription() {
    return `(${this.job.JobId}) ${this.job.TypeDescription}`;
  }

  get divisionDescription() {
    return `${this.job.DivisionName} (${this.job.AddressPostcode})`;
  }

  get statusUpdated() {
      return `Moved into ${this.job.LastStatus}`;
  }

  get statusChangedDateTime() {
      return `${this.job.StatusChangeTime.format("DD-MM-YYYY")} at ${this.job.StatusChangeTime.format("HH:mm")}`;
  }

  

  private displayDate(date: moment.Moment): string {
    return date.format("DD-MM-YYYY");
     
  }
}
